<script>
    import { menu } from "../../../stores";
    import { Link } from "svelte-routing";
    import Fa from "svelte-fa";
    import { faAddressBook, faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
    
    function getProps({ location, href, isPartiallyCurrent, isCurrent }) {
      const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;
  
      // The object returned here is spread on the anchor element's attributes
      if (isCurrent) {
        return { class: "menu-item active" };
      }
      return { class: "menu-item"};
    }

    let expanded = true;
  </script>
  
  <li>
    <button class="menu-item" on:click={() => expanded = !expanded}>
      {#if $$slots["icon"]}
        <div class="icon">
          <slot name="icon"></slot>
        </div>
      {/if}
      <div class="title">
        <slot name="title"/>
      </div>
      <div class="arrow">
        {#if expanded}
          <Fa
            icon={faCaretDown}
          />
        {:else}
          <Fa
            icon={faCaretRight}
          />
        {/if}
      </div>
    </button>
    {#if expanded}
      <div class="menu-item-child-container">
        <slot></slot>
      </div>
    {/if}
  </li>

  <style>
    li {
      flex: 1;
    }

    button {
      width: 100%;
      background-color: transparent;
      cursor: pointer;
      line-height: 1.5;
    }

    :global(.menu-item) {
      box-sizing: border-box;
      /* height: 4rem; */
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 1rem 1.5rem;
      border-radius: 0.5rem;
      transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
    }

    :global(.menu-item),
    :global(.menu-item:active),
    :global(.menu-item:visited) {
      color: rgba(0, 0, 0, 0.8);
    }

    :global(.menu-item.active) {
      /* font-weight: bold; */
      /* border-bottom: 1px solid transparent; */
      /* color: rgba(0, 0, 0, 0.8); */
      background-color: #ebe6e2;
      border-radius: 20px;
    }

    :global(.menu-item:hover),
    :global(.menu-item:focus) {
      background-color: #ebe6e2;
      text-decoration: none;
      color: rgba(0, 0, 0, 0.8);
      border-radius: 20px;
      /* color: blue; */
    }

    .icon {
      margin-right: 1rem;
    }

    .title {
      flex: 1;
      text-align: left;
    }

    .menu-item-child-container {
      margin: 0 0 0 2rem;
      /* margin-left: 32px; */
      padding-left: 0.5rem;
      /* border-left: 2px solid #ebe6e2; */
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .menu-item-child-container::before {
      content: "";
      position: absolute;
      left: 0;
      top: 1rem;
      bottom: 1rem;
      width: 2px;
      background-color: #ebe6e2;
    }

    :global(.menu-item-child-container>a) {
      color: rgba(0, 0, 0, 0.8);
      text-decoration: none;
      padding: 1rem 1.5rem;
      line-height: 1;
      border-radius: 0.5rem;
      transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
    }

    :global(.menu-item-child-container>a:hover) {
      background-color: #ebe6e2;
      border-radius: 20px;
    }
  </style>

